import { useStore } from '../store/hooks'

export const useAuthHeaders = () => {
  const token = useStore(s => s.auth?.token)

  return { headers: { Authorization: `Bearer ${token}` } }
}
